import maintenanceApi from "@/config/maintenanceApi";

export const getMaintenanceData = async (url: string, token?: string) => {
  const headers: any = {};
  if (token) {
    headers.authorization = `Token ${token}`;
  }
  const response = await maintenanceApi.get(url, { headers });
  return response.data;
};
